import { render, staticRenderFns } from "./mrc_ess_colorPicker.vue?vue&type=template&id=53247b94&scoped=true&"
import script from "./mrc_ess_colorPicker.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_colorPicker.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_colorPicker.vue?vue&type=style&index=0&id=53247b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53247b94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VColorPicker,VCombobox,VMenu})
